import { GridActionsCellItem } from '@mui/x-data-grid';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { useWatch } from 'react-hook-form';

import { NetZeroActionsProps } from './NetZeroActions';
import ModalNetZero from '../ModalNetZero/ModalNetZero';
import { useDisclosure } from '@hooks/useDisclosure';
import { useGreenhouseForm } from '@Router/EsgGreenhouse/Containers/EsgGreenhouseFormProvider';

const NetZeroEditButton = ({ rowId }: NetZeroActionsProps) => {
  const [opened, { open, close }] = useDisclosure();
  const { getValues } = useGreenhouseForm();

  const { completedSection } = useWatch({ name: 'greenhouseGoalTerm' });
  const { isCompletedTh, isCompletedEn } = completedSection ?? {};

  const netZeroDetails = getValues().greenhouseGoalTerm?.netZero?.details || [];
  const isNewDetail = typeof rowId === 'string';
  const currentIndex = isNewDetail
    ? Number(rowId.replace('NEW-', '')) - 1
    : netZeroDetails.findIndex((detail) => detail.id === rowId);
  const editData = netZeroDetails[currentIndex];

  return (
    <>
      <GridActionsCellItem
        key="edit"
        icon={<EditOutlinedIcon style={{ fontSize: '16px' }} />}
        label="Edit"
        onClick={open}
        disabled={isCompletedTh && isCompletedEn}
      />
      {opened && (
        <ModalNetZero
          mode="edit"
          open={opened}
          close={close}
          currentIndex={currentIndex}
          editData={editData}
        />
      )}
    </>
  );
};

export default NetZeroEditButton;
